import { render, staticRenderFns } from "./UserFormLog.vue?vue&type=template&id=d5f5c924&"
import script from "./UserFormLog.vue?vue&type=script&lang=js&"
export * from "./UserFormLog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports